import { IController, IScope } from "angular";
import {  } from "@idha/idha-types";
import * as Raven from 'raven-js'
import { utilsModule } from "../../utils-module";
import { Country, IGeoDatabase } from "@idha/idha-utils";

/**
 * @ngdoc component
 * @name app.component:countrySelector
 * @author William
 * @email william@idha.com.br
 * @description 
 * 
 * <b>IDHA TECNOLOGIA</b>
 * 
 * Nome do Componente: 'countrySelector'
 * 
 * Criação: 2018-12-27 17:34:32
 * 
 * Código do componente: CMP0001
 * 
 * Autor:  William 
 * 
 * Componente para listagem e seleção de países
 * 
 * @see http://wiki.idha.com.br/index.php/CMP0001_-_Seletor_de_Pa%C3%ADs
 * 
 * @param {string} label label do componente. Se omitido, é considerado 'País'
 * @param {string} ngModel nome do país selecionado
 * @param {string} selectionType tipo de seleção. 'UNIQUE' ou 'MULTIPLE'. O valor padrão é 'UNIQUE'.
 * @param {boolean} ngRequired indica se o campo é obrigatório ou não
 * @param {boolean} ngDisabled indica se o campo é desabilitado ou não
 * @param {boolean} showError indica se as mensagens de erro devem ou não ser exibidas
 * @param {string} form nome do formulário em que o componente está inserido
 * @param {string} class classe css a ser aplicada ao componente
 * @param {string} inputName nome do input. Se omitido, o nome "inpCountry" é usado(opcional)
 * @param {Array.Country} countryList Lista de países a serem exibidos
 * @param {Function} onChangeSelection Callback disparado quando o item selecionado é alterado
 * @param {Function} onChangeText Callback disparado quando o texto do componente é alterado
 */
utilsModule.component('countrySelector', {
    template: require('./country-selector.component.html'),
    controller: ['geoDBService','$timeout',countrySelectorController],
    bindings: {
        label: '@?',        
        countryList:'=?',
        selectionType:'=?',
        ngModel:'=',
        ngRequired:'<?',
        ngDisabled:'=?',
        showError:'<?',
        form:'=?',
        class:'@?',
        inputName:'@?',
        onChangeText:'=',
        onChangeSelection:'='
    }
})

/**
 * @interface
 * @ngdoc controller 
 * @name app.controller:CountrySelectorController 
 * @description
 * 
 * Interface do controlador do componente countrySelector
 */
export interface CountrySelectorController extends IController {
    /**
     * @ngdoc property
     * @name CountrySelectorController#label
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * label do componente. Se omitido, é considerado 'País'
     */
    label: string

    /**
     * @ngdoc property
     * @name CountrySelectorController#countryList
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * lista de países a serem exibidos para seleção
     */
    countryList: Country[]
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#ngModel
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * nome do país selecionado
     */
    ngModel:string
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#ngRequired
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * indica se o campo é obrigatório ou não
     */
    ngRequired:boolean
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#ngDisabled
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * indica se o campo é desabilitado ou não
     */
    ngDisabled:boolean
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#showError
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * indica se as mensagens de erro devem ou não ser exibidas
     */
    showError:boolean
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#form
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * nome do formulário em que o componente está inserido
     */
    form:string
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#searchText
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * texto da busca de país
     */
    searchText:string
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#class
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * classe css a ser aplicada ao componente
     */
    class:string
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#inputName
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * nome do input. Se omitido, o nome "inpCountry" é usado. 
     * É um parametro opcional
     */
    inputName:string

    /**
     * @ngdoc property
     * @name CountrySelectorController#filterCountries
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * Filtra a lista de países
     * 
     * @param {string} search texto para filtrar a lista de paises
     * @return {strin} retorna a lista de paises derivada da busca
     */
    filterCountries:(search:string)=>Promise<string[]>
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#onChangeSelection
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * Callback disparado quando o item selecionado é alterado
     */
    onChangeSelection:()=>void
    
    /**
     * @ngdoc property
     * @name CountrySelectorController#onChangeText
     * @propertyOf app.controller:CountrySelectorController
     * @description
     * 
     * Callback disparado quando o texto do componente é alterado
     */
    onChangeText:()=>void
}


/**
 * @name app.controller:countrySelectorController 
 * @implements CountrySelectorController 
 * @description
 * 
 * Controlador do componente countrySelector
 */
function countrySelectorController(geoDBService:IGeoDatabase,$timeout) {
    var ctrl: CountrySelectorController = this;


    ctrl.$onInit = async function(){
        if(!ctrl.inputName) ctrl.inputName = 'inpCountry';

        if(!ctrl.countryList){
            ctrl.countryList = await geoDBService.listCountries();
            ctrl.countryList.sort((country1:Country,country2:Country)=>{
                return country1.name.localeCompare(country2.name);
            })
        }

        /*
        * @TODO: Trecho necessário devido a um bug no ng-required, no qual quando o mesmo é inicializado com FALSE,
        * o  mesmo é ignorado e a validação é feita, a menos que entre no campo, digite algo e depois apague.
        * Este trecho faz com que, nesses casos, a validação '''Required''' seja forçada para TRUE, indicando 
        * que o formulário é valido.
        * 
        * O timeout é utilizado sem parametro de tempo para garantir apenas que seja executado apos o ciclo de $digest,
        * onde os campos do formulario ja foram todos criados.    
        */
        $timeout(()=>{
            if(ctrl.form && ctrl.form[ctrl.inputName]){
                if(!ctrl.ngRequired){
                    ctrl.form[ctrl.inputName].$setValidity('required', true);
                }
            }
        })
    }

    ctrl.filterCountries = async function(searchText:string):Promise<string[]>{    
        if(!ctrl.countryList) return [];

        if(searchText.length < 3) return [];

        await ctrl.countryList;
        
        return ctrl.countryList.filter((country:Country)=>{
            return country.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1
        }).map((country:Country)=>{
            return country.name
        })
    }
}